module.exports = __webpack_public_path__ + "img/symbol_11.feac75c5.png";